//@flow
import { maxIcon }  from "../../_common/icons/maxIcon"

export const getCartButton = (attributes: *, productPurchsability: string) => {

    if(attributes && attributes.length > 0) {
        const addCartElement = document.createElement('add-to-cart');
        addCartElement.textContent = productPurchsability;

        for(var i = attributes.length - 1; i >= 0; i--) {
            if(attributes[i].name !== "class") {
                addCartElement.setAttribute(attributes[i].name, attributes[i].value);
            }
        }

        return addCartElement;
    }

    return null;
}

export const getInstoreOnlyButton = (productPurchsability: string) => {

    const instoreButtonEle = document.createElement('button');
    const buttonText = document.createElement('span');

    buttonText.classList.add('button-text');
    buttonText.textContent = productPurchsability;

    instoreButtonEle.classList.add('product-tile__action-btn');
    instoreButtonEle.classList.add('product-tile__action-btn--instore-purchase');
    instoreButtonEle.disabled = true;
    instoreButtonEle.appendChild(buttonText);

    return instoreButtonEle;
}

export const getTradeAccountOnlyButton = () => {

    const tradeAccountOnlyButtonEle = document.createElement('button');
    const buttonText = document.createElement('span');

    buttonText.classList.add('button-text');
    buttonText.textContent = 'Trade Accounts only';

    tradeAccountOnlyButtonEle.disabled = true;
    tradeAccountOnlyButtonEle.classList.add('product-tile__action-btn');
    tradeAccountOnlyButtonEle.classList.add('product-tile__action-btn--max-users-only');
    tradeAccountOnlyButtonEle.appendChild(buttonText);

    return tradeAccountOnlyButtonEle;
}

export const getCreativeGlassButton = (productPurchsability: string) => {

    const creativeGlassButtonEle = document.createElement('button');
    const buttonText = document.createElement('span');

    buttonText.classList.add('button-text');
    buttonText.textContent = productPurchsability;

    creativeGlassButtonEle.classList.add('product-tile__action-btn');
    creativeGlassButtonEle.classList.add('product-tile__action-btn--selected-area-only');
    creativeGlassButtonEle.setAttribute('onclick', 'location="'+"/creative-glass"+'"');
    creativeGlassButtonEle.appendChild(buttonText);

    return creativeGlassButtonEle;
}

export const getEnquireOnlyButton = (secureUrl: string, productPurchsability: string) => {
    const enquireOnlyButtonEle = document.createElement("button");
    const buttonText = document.createElement("span");

    buttonText.classList.add("button-text");
    buttonText.textContent = productPurchsability;

    enquireOnlyButtonEle.classList.add("product-tile__action-btn");
    enquireOnlyButtonEle.classList.add("product-tile__action-btn--enquire-only");
    enquireOnlyButtonEle.setAttribute("onclick", 'location="' + secureUrl + '"');
    enquireOnlyButtonEle.appendChild(buttonText);

    return enquireOnlyButtonEle;
};

export const getShopInMaxButton = (secureUrl: string, productPurchsability: string) => {
    const shopInMaxButtonEle = document.createElement('button');
    const buttonText = document.createElement('span');
    let isNz = false;
    const isMax = (window.document.querySelector("[data-user-type='MAX_USER']") && true) || (productPurchsability === "Shop in maX");

    if (window.location.host.indexOf('.co.nz') > -1) {
        isNz = true;
    }

    buttonText.classList.add('button-text');
    shopInMaxButtonEle.classList.add('product-tile__action-btn');

    if(isNz && isMax) {
        buttonText.innerHTML = `Shop in <span class="max-icon">${maxIcon}</span>`;
        shopInMaxButtonEle.classList.add('product-tile__action-btn--shop-in-max', 'shop-in-max-nz');
    } else {
        buttonText.textContent = productPurchsability;
        shopInMaxButtonEle.classList.add('product-tile__action-btn--shop-in-max');
    }

    shopInMaxButtonEle.setAttribute('onclick', 'location="'+secureUrl+'"');
    shopInMaxButtonEle.appendChild(buttonText);

    return shopInMaxButtonEle;
}
